import {registerBrick} from 'olympe';
import {ReactBrick} from '@olympeio/core';
import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import {orangeTheme} from './_theme';
import {Menu, MenuItem, ThemeProvider} from '@mui/material';
import {
    getCompanyCodeDisablingDYNLambda,
    isCandexEnabledLambda,
    isNestBuyCCEnabledLambda,
} from '../utils/functionSignatures';
import CircularProgress from '@mui/material/CircularProgress';
import {LAMBDA_NAMES} from '../utils/constants';

/**
 * This brick is displaying 1 or 2 options to create a new request, based on the user default company code
 */
export default class AddRequestButton extends ReactBrick {
    /**
     * @override
     */
    static getReactComponent($) {
        return () => {
            const [anchorEl, setAnchorEl] = useState(null);
            const [displayDYNOption, setDisplayDYNOption] = useState(false);
            const [displayCandexOption, setDisplayCandexOption] = useState(false);
            const [displayNestBuyOption, setDisplayNestBuyOption] = useState(false);
            const [loading, setLoading] = useState(false);
            const open = Boolean(anchorEl);

            useEffect(() => {
                if (open) {
                    setLoading(true);
                    const displayDYN = getCompanyCodeDisablingDYNLambda($, $.get(LAMBDA_NAMES.CHECK_COMPANY_CODE));
                    const displayCandex = isCandexEnabledLambda($, $.get(LAMBDA_NAMES.CHECK_IF_CANDEX_IS_ENABLED));
                    const displayNestBuy = isNestBuyCCEnabledLambda($, $.get(LAMBDA_NAMES.CHECK_IF_NESTBUY_CC_IS_ENABLED));
                    const wait = new Promise((resolve) => setTimeout(resolve, 400));

                    // We add this 400 ms pause, otherwise the company code fetching could be so fast that the spinner is displayed
                    // and immediately removed, and it seems to be bugged
                    Promise.all([
                        displayDYN,
                        displayCandex,
                        displayNestBuy,
                        wait,
                    ])
                        .then((values) => {
                            setDisplayDYNOption(values[0][0]);
                            setDisplayCandexOption(values[1][0]);
                            setDisplayNestBuyOption(values[2][0]);
                            setLoading(false);
                        });
                }
            }, [open]);
            const handleClick = (event) => {
                setAnchorEl(event.currentTarget);
            };

            const handleClose = () => {
                setAnchorEl(null);
            };

            const handleClickOnGoToPSL = () => {
                setAnchorEl(null);
                $.trigger('On click on Go To PSL');
            };

            const handleClickOnDYN = () => {
                setAnchorEl(null);
                $.trigger('On click on DYN');
            };

            const handleClickOnCandex = () => {
                setAnchorEl(null);
                $.trigger('On click on Candex');
            };

            const handleClickOnNestBuy = () => {
                setAnchorEl(null);
                $.trigger('On click on NestBuy');
            };

            return (
                <ThemeProvider theme={orangeTheme}>
                    <div>
                        <Button
                            fullWidth
                            sx={{'color': 'white', 'boxShadow': 'none', '&:hover': {boxShadow: 'none'}}}
                            variant="contained"
                            onClick={handleClick}
                            disableElevation
                        >+ Add request</Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            {
                                loading ?
                                    <div className={'add-request-button-spinner'}>
                                        <CircularProgress size={18}/>
                                    </div> :
                                    <div>
                                        <MenuItem onClick={handleClickOnGoToPSL}>Go to PSL</MenuItem>
                                        {displayDYNOption &&
                                            <MenuItem onClick={handleClickOnDYN}>Describe your needs</MenuItem>
                                        }
                                        {displayCandexOption &&
                                            <MenuItem onClick={handleClickOnCandex}>Candex Catalog</MenuItem>
                                        }
                                        {displayNestBuyOption &&
                                            <MenuItem onClick={handleClickOnNestBuy}>NestBuy Catalog</MenuItem>
                                        }
                                    </div>
                            }
                        </Menu>
                    </div>
                </ThemeProvider>
            );
        };
    }
}

registerBrick('018e75bc1d19d44f5530', AddRequestButton);
